module.exports = __webpack_public_path__ + "static/media/icon_download-sm.a375783d.svg";